import {
  Box,
  Text,
  Flex,
  VStack,
  HStack,
  Badge,
  Button,
  Tooltip,
  Collapse,
  useDisclosure,
  Icon,
  Divider,
  useToast,
} from '@chakra-ui/react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { useState } from 'react';
import PointsExpirationRulesModal from '../../components/AdminComponents/PointsExpirationRulesModal';
import PromotionBuilderModal from '../../components/AdminComponents/PromotionBuilderModal';
import SendNotificationBuilderModal from '../../components/AdminComponents/SendNotificationBuilderModal';

const campaigns = [
  { name: 'Fall Bonus', status: 'active' },
  { name: 'Holiday Prep', status: 'draft' },
  { name: 'Referral Boost', status: 'ended' },
];

const AdminNotificationCenter = () => {
  const toast = useToast();
  const disclosure = useDisclosure();
  const [showPromoModal, setShowPromoModal] = useState(false);
  const [showExpiryModal, setShowExpiryModal] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'green';
      case 'draft':
        return 'yellow';
      case 'ended':
        return 'gray';
      default:
        return 'gray';
    }
  };

  const handlePromotionSaved = (data) => {
    toast({
      title: 'Promotion Saved',
      description: 'Promotion was successfully saved.',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
  };

  return (
    <Box p={6} maxW="960px" mx="auto" borderWidth="1px" borderRadius="lg" shadow="md">
      <Flex justify="space-between" align="center" mb={4}>
        <Text fontSize="2xl" fontWeight="bold">LOYALTY ADMIN DASHBOARD</Text>
        <Text fontWeight="medium">Notifications</Text>
      </Flex>

      <Flex gap={6} wrap="wrap">
        <Box flex="1" minW="250px">
          <Text fontWeight="bold" mb={2}>CAMPAIGNS ({campaigns.length})</Text>
          <VStack align="start" spacing={3}>
            {campaigns.map((c) => (
              <Flex key={c.name} align="center" gap={3}>
                <Badge colorScheme={getStatusColor(c.status)}>{c.name}</Badge>
                <Text fontSize="sm" color="gray.500">
                  ({c.status.charAt(0).toUpperCase() + c.status.slice(1)})
                </Text>
              </Flex>
            ))}
          </VStack>
        </Box>

        <Box flex="1" minW="250px">
          <Text fontWeight="bold" mb={2}>EXPIRATIONS</Text>
          <Text>Next Wave: <strong>15,382 pts</strong></Text>
          <Text fontSize="sm" color="gray.600">in 7 days</Text>
          <Text fontSize="sm" color="gray.500">892 customers</Text>
        </Box>

        <Box flex="1" minW="250px">
          <Text fontWeight="bold" mb={2}>METRICS</Text>
          <VStack align="start">
            <Tooltip label="Redemption rate increased" placement="right">
              <Text>↗ 12%</Text>
            </Tooltip>
            <Tooltip label="Engagement dropped slightly" placement="right">
              <Text>↘ 8%</Text>
            </Tooltip>
            <Tooltip label="Retention stable" placement="right">
              <Text>→ 45%</Text>
            </Tooltip>
          </VStack>
        </Box>
      </Flex>

      <Divider my={6} />

      <Text fontWeight="bold" mb={2}>QUICK ACTIONS:</Text>
      <HStack spacing={4} wrap="wrap">
        <Button colorScheme="blue" onClick={() => setShowPromoModal(true)}>Create Promotion</Button>
        <Button colorScheme="orange" onClick={() => setShowExpiryModal(true)}>Adjust Expiry</Button>
        <Button colorScheme="teal" onClick={() => setShowNotificationModal(true)}>Send Notification</Button>
      </HStack>

      <PromotionBuilderModal
        show={showPromoModal}
        onHide={() => setShowPromoModal(false)}
        promotion={null}
        onPromotionSaved={handlePromotionSaved}
      />

      <PointsExpirationRulesModal
        isOpen={showExpiryModal}
        onClose={() => setShowExpiryModal(false)}
      />

      <SendNotificationBuilderModal
        isOpen={showNotificationModal}
        onClose={() => setShowNotificationModal(false)}
        onSend={(payload) => console.log('Notification Payload:', payload)}
      />

      <Divider my={6} />

      <Flex justify="space-between" align="center" onClick={disclosure.onToggle} cursor="pointer">
        <Text fontWeight="bold">RECENT ACTIVITY</Text>
        <Icon as={disclosure.isOpen ? FiChevronUp : FiChevronDown} />
      </Flex>

      <Collapse in={disclosure.isOpen} animateOpacity>
        <VStack align="start" mt={3} spacing={2}>
          <Text fontSize="sm">• Oct 12: Fall Bonus activated (You)</Text>
          <Text fontSize="sm">• Oct 10: 1,203 pts expired automatically</Text>
        </VStack>
      </Collapse>
    </Box>
  );
};

export default AdminNotificationCenter;
